import { gql } from '@apollo/client';

export default gql`
  mutation processHotelCardRefund($bookingReference: String!, $pspReference: String!, $refundAmount: Float!, $currency: Currency!) {
    processHotelCardRefund(
      bookingReference: $bookingReference
      pspReference: $pspReference
      refundAmount: $refundAmount
      currency: $currency
      location: EBSC
    ) {
      reference
      paymentsRefundBalance
    }
  }
`;
